export const getPaymentStatusColor = (status) => {
  if (status.includes('ERROR') || status.includes('FAILED') || status.includes('REJECTED')) {
    return '#f00';
  } else if (status.includes('SUCCEEDED')) {
    return '#4abc4e';
  } else if (status.includes('PROCESSING') || status.includes('PROCESSED')) {
    return '#2c93ff';
  } else if (status.includes('APPROVED')) {
    return '#887fff';
  } else if (status.includes('PENDING')) {
    return '#FBA10D';
  }

  return 'inherit';
};
